import React, { useEffect, useState } from "react";
import CategoriesGrid from "./CategoriesGrid";
import { useCity } from "../context/CityContext";
import { getEventsByCategory } from "../services/eventService";

const AllCategories = () => {
  const { city } = useCity();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (city) {
      fetchData();
    }
  }, [city]);

  const fetchData = async () => {
    try {
      setLoading(true);

      // 0 = return all categories grouped
      const response = await getEventsByCategory(0, city, false);
      setCategories(response.data || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="px-6 py-10 text-center">
        Loading categories...
      </div>
    );
  }

  if (!Array.isArray(categories) || categories.length === 0) {
    return (
      <div className="px-6 py-10 text-center">
        No categories available
      </div>
    );
  }

  return (
    <div className="px-0 py-10 max-w-[1300px] mx-auto">

      {/* Page Heading */}
      <h1 className="text-3xl font-semibold font-['Inter'] text-left mb-8">
        All Categories
      </h1>

      {/* Render Each Category Using CategoriesGrid */}
      {categories.map((category, index) => (
        <CategoriesGrid
          title={category.categoryName}
          categories={category.children}
           limit={5}
          showViewAll={true}

        />
      ))}
    </div>
  );
};

export default AllCategories;